import { useContext } from "react";
import { TemplateVersionContext } from "../providers/template-version";

export const useTemplateVersion = () => useContext(TemplateVersionContext);
